import PropTypes from 'prop-types'

import Controls from '@aytm/app/stats/page/question-views/mn/components/controls/Controls'
import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'

import oeStyle from '@aytm/app/stats/page/question-views/oe/components/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const CommentsControls = ({ title, collapsed, onToggle, disabled, ...oeProps }) => (
  <>
    <Controls title={title} collapsed={collapsed} onToggle={onToggle} />
    {!collapsed && !disabled && (
      <div className={`${oeStyle.component} p-fluid ${NO_PRINT}`}>
        <ControlsComponents disabled={disabled} {...oeProps} />
      </div>
    )}
  </>
)

CommentsControls.propTypes = {
  title: PropTypes.string,
  collapsed: PropTypes.bool,
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  isVerbatimType: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onViewModeChange: PropTypes.func,
  onConfigChange: PropTypes.func,
  onExport: PropTypes.func,
  onToggle: PropTypes.func
}

CommentsControls.displayName = 'CommentsControls'

export default CommentsControls
